import React, { useState, useEffect } from 'react';
import Header from './Header';
import { useParams } from 'react-router-dom';
import '../style/SingleBookScreen.css';
import { buildApiUrl, buildImageUrl } from '../utils/apiClient';

function SingleBookScreen() {
	const { book_id } = useParams();
	const [book, setBook] = useState(null);
	const [category, setCategory] = useState(null);

	useEffect(() => {
		fetch(buildApiUrl(`/api/book/${book_id}`))
			.then(res => res.json())
			.then(data => {
				console.log('Fetched book:', data); // Log the fetched book data
				setBook(data);

				// Fetch category information if categoryID is available
				if (data.categoryID) {
					fetch(buildApiUrl(`/api/category/${data.categoryID}`))
						.then(res => res.json())
						.then(categoryData => {
							console.log('Fetched category:', categoryData); // Log the fetched category data
							setCategory(categoryData);
						})
						.catch(error => console.error('Failed to fetch category:', error));
				}
			})
			.catch(error => console.error('Failed to fetch book:', error));
	}, [book_id]);

	if (!book) {
		return <p>Loading book details...</p>;
	}

	const status = book.status;
	const isEbook = status === 'EBOOK';
	const isChinaOnly = status === 'CHINA_ONLY';
	const showClassification = !(isEbook || isChinaOnly);
	const litresLinkRaw = typeof book.litresLink === 'string' ? book.litresLink.trim() : '';
	const litresLink = litresLinkRaw.replace(/\s+/g, '');
	const showLitresRow = isEbook && litresLink.length > 0;
	const badgeText = isEbook ? 'Электронная книга' : isChinaOnly ? 'Распространяется в КНР' : null;
	const availabilityText = (() => {
		if (isEbook) {
			return 'Электронная книга';
		}
		if (isChinaOnly) {
			return 'Распространяется в КНР';
		}
		return book.isBeingSold ? 'В продаже' : 'Книгу можно заказать в центральных библиотеках России';
	})();
	const isbnValue = book.isbnCode || book.n32Code;

	return (
		<div>
			<div className="header-bg-default">
				<Header />
			</div>
			<div style={{ paddingLeft: '5%', paddingTop: '50px' }}>
				<h2>{book.name}</h2>
				{badgeText && <div className="book-status-badge">{badgeText}</div>}
				<div style={{ display: 'flex' }}>
					<div className='book-image'>
						<img src={buildImageUrl(book.imageURL)} alt={book.name} />
					</div>
					<div className="book-details" style={{ marginLeft: '10%' }}>
						<div className="book-detail-row">
							<div className="book-detail-label">Статус:</div>
							<div className="book-detail-content">{availabilityText}</div>
						</div>
						<div className="book-detail-row">
							<div className="book-detail-label">Год публикации:</div>
							<div className="book-detail-content">{book.publishmentYear}</div>
						</div>
						<div className="book-detail-row">
							<div className="book-detail-label">Жанр:</div>
							<div className="book-detail-content">{category ? category.name : 'N/A'}</div>
						</div>
						<div className="book-detail-row">
							<div className="book-detail-label">Количество страниц:</div>
							<div className="book-detail-content">{book.numPages}</div>
						</div>
						{showLitresRow && (
							<div className="book-detail-row">
								<div className="book-detail-label">ЛитРес:</div>
								<div className="book-detail-content">
									<a href={litresLink} target="_blank" rel="noopener noreferrer" title={litresLink}>Читать на Литрес</a>
								</div>
							</div>
						)}
						{showClassification && (
							<div className="book-detail-row">
								<div className="book-detail-label">УДК:</div>
								<div className="book-detail-content">{book.udkCode}</div>
							</div>
						)}
						{showClassification && (
							<div className="book-detail-row">
								<div className="book-detail-label">ББК:</div>
								<div className="book-detail-content">{book.bbkCode}</div>
							</div>
						)}
						<div className="book-detail-row">
							<div className="book-detail-label">ISBN:</div>
							<div className="book-detail-content">{isbnValue}</div>
						</div>
					</div>
				</div>

				<h3 className='description'>Описание</h3>
				<p className='book-description'>{book.description}</p>
			</div>
		</div>
	);
}

export default SingleBookScreen;
